import React from 'react';
import { useFormContext } from 'react-hook-form';
import { resolveUrlFix } from '../../utils/validators';

const UrlSpaceFixButton: React.FC<{
  name: string;
  disabled?: boolean;
  requireHttps?: boolean;
}> = ({ name, disabled = false, requireHttps = false }) => {
  const { watch, setValue } = useFormContext();
  const value: string = watch(name) || '';
  const fix = resolveUrlFix(value, requireHttps);

  if (disabled || !fix) return null;

  const handleFix = () => {
    setValue(name, fix.next, { shouldValidate: true, shouldDirty: true });
  };

  return (
    <button
      type="button"
      onClick={handleFix}
      className="ml-2 font-medium text-indigo-600 underline hover:text-indigo-800"
    >
      {fix.label}
    </button>
  );
};

export default UrlSpaceFixButton;
